export function calculateTotalPackagePrice(packagePrice: number, numberOfGuests: number) {
  const signForPricing = process.env.REACT_APP_CURRENCY_SYMBOL

  if (numberOfGuests <= 0) {
    throw new Error("Number of guests must be greater than 0.");
  }
  // Calculate the total package price
  const totalPrice = packagePrice;

  let discount = 0;
  let discountMessage = "";

  // Determine discount and message based on total price
  const currentDate = new Date();
  const blackFridayEndDate = new Date("2025-12-02T23:59:59");

  if (process.env.REACT_APP_PROJECT_COUNTRY === "uk") {
    // Black Friday discount: £200 per booking if booked before end of Tuesday 2nd December 2025
    // Minimum spend: £5,000
    // if (currentDate <= blackFridayEndDate && totalPrice >= 5000) {
    //   discount = 200;
    //   discountMessage = `‘Special Offer ${signForPricing}200 off`;
    // }
    // if (currentDate < cutoffDate) {
    // if (totalPrice >= 10000) {
    //   discount = 400;
    //   discountMessage = `‘Special Offer ${signForPricing}400 off’`;
    // if (totalPrice >= 6000) {
    //   discount = 200;
    //   discountMessage = `Includes ${signForPricing}200 online discount`;
    // } else if (totalPrice >= 5000) {
    //   discount = 150;
    //   discountMessage = `Includes ${signForPricing}150 online discount`;
    // }
    // // below 5000 discount is 100 on TOTAL package price
    // else if (totalPrice < 5000) {
    //   discount = 100;
    //   discountMessage = `Includes ${signForPricing}100 online discount`;
    // }
    // else if (totalPrice >= 3000) {
    //   discount = 100;
    //   discountMessage = `‘Special Offer ${signForPricing}100 off’`;
    // }
    // else if (totalPrice >= 2000) {
    //   discount = 50;
    //   discountMessage = `‘Special Offer ${signForPricing}50 off’`;
    // }
    // else {
    //   // Standard discount
    discount = 100;
    discountMessage = `‘Special Offer ${signForPricing}100 off’`;
    // }
  }
  else if (`${process.env.REACT_APP_PROJECT_COUNTRY}` === "ie") {
    // Black Friday discount: £200 per booking if booked before end of Tuesday 2nd December 2025
    // Minimum spend: £5,000
    // if (currentDate <= blackFridayEndDate && totalPrice >= 5000) {
    //   discount = 200;
    //   discountMessage = `‘Special Offer ${signForPricing}200 off`;
    // }
    // if (totalPrice >= 6000) {
    //   discount = 200;
    //   discountMessage = `Includes ${signForPricing}200 online discount`;
    // } else if (totalPrice >= 5000) {
    //   discount = 150;
    //   discountMessage = `Includes ${signForPricing}150 online discount`;
    // }
    // else if (totalPrice < 5000) {
    //   discount = 100;
    //   discountMessage = `Includes ${signForPricing}100 online discount`;
    // }
    // else if (totalPrice >= 4000) {
    //   discount = 150;
    //   discountMessage = `‘Special Offer ${signForPricing}150 off’`;
    // }
    // else if (totalPrice >= 3000) {
    //   discount = 100;
    //   discountMessage = `‘Special Offer ${signForPricing}100 off’`;
    // }
    // else if (totalPrice >= 2000) {
    //   discount = 50;
    //   discountMessage = `‘Special Offer ${signForPricing}50 off’`;
    // }
    // else {
    //   // Standard discount
    discount = 100;
    discountMessage = `‘Special Offer ${signForPricing}100 off’`;
    // }
  }

  const finalPriceDiscount = totalPrice - discount;

  return {
    finalPriceDiscount,
    discountMessage,
  };
}
